// extracted by mini-css-extract-plugin
export default {"statistics-collection":"trndOHuZEf6ZJLQZhxyw","counter-card":"H76dJCfIGIRRNBDkiS3K","label":"nM45a1ps0v1fNfZdNdkL","clickable":"jNGvJr62EN8L7idv3NQA"};